module.exports = __webpack_public_path__ + "static/media/bs_2.4d66ecf8.jpg";